// 주문/반품 상태 공통 정의 (DB 값과 동일하게 유지)
// 라벨은 i18n 키로 정의됨 → 컴포넌트에서 t() 호출 시 사용

// 주문 상태 (orders 테이블)
export const ORDER_STATUS_KEYS = [
  "pending",
  "confirmed",
  "printing",
  "printed",
  "shipping",
  "delivered",
  "cancelled",
];

export const ORDER_STATUS_COLORS = {
  pending: "#f59e0b",
  confirmed: "#3b82f6",
  printing: "#8b5cf6",
  printed: "#10b981",
  shipping: "#06b6d4",
  delivered: "#6b7280",
  cancelled: "#ef4444",
};

// 반품/교환 상태 (returns 테이블)
export const RETURN_STATUS_KEYS = [
  "pending",
  "approved",
  "collecting",
  "collected",
  "completed",
  "rejected",
  "withdrawn",
];

export const RETURN_STATUS_COLORS = {
  pending: "#f59e0b",
  approved: "#3b82f6",
  collecting: "#8b5cf6",
  collected: "#06b6d4",
  completed: "#10b981",
  rejected: "#ef4444",
  withdrawn: "#9ca3af",
};

/**
 * 주문 상태 라벨 (i18n 적용)
 * @param {function} t - useTranslation 의 t 함수
 * @returns {object} { pending: "접수대기", ... }
 */
export function buildOrderStatusMap(t) {
  const map = {};
  ORDER_STATUS_KEYS.forEach((k) => {
    map[k] = t(`orderStatus.${k}`);
  });
  return map;
}

/**
 * 반품 상태 라벨 (i18n 적용)
 */
export function buildReturnStatusMap(t) {
  const map = {};
  RETURN_STATUS_KEYS.forEach((k) => {
    map[k] = t(`returnStatus.${k}`);
  });
  return map;
}
